
<div class="flex flex-column mt-4 align-items-center justify-content-center">
  <ng-container *ngIf="cotizacion == undefined; else elseTemplate">
    <div class="flex align-items-center justify-content-center" style="margin-top: 25%;">
      <mat-spinner [diameter]="40"></mat-spinner>
    </div>
    <div class="flex-1 flex align-items-center justify-content-center" style="margin-top: 50px;">
      <h3>Estamos solicitando la póliza</h3>
    </div>
    <div class="flex-1 flex align-items-center justify-content-center text-center">
    <h3>Aguarde un instante...</h3>
    </div>
  </ng-container>
  <ng-template #elseTemplate>

    <ng-container *ngIf="cotizacion?.reporte == '' && cotizacion?.resultado == 'OK'; else emitida">
      <mat-card class="cotizacion mt-2" style="max-width: 50%;">
        <mat-card-header>
          <div class="text-center">
            <h2 style="color: var(--secondary-500);">{{ nombre | titlecase }}</h2>
            <p>Ya tenemos tu póliza</p>

          </div>
        </mat-card-header>
        <div class="text-center" style="background-color: #fff;">
          <img mat-card-image class="mt-2" src="assets/iconos/logosmg.png" alt="SMG Seguros" width="150px">
        </div>
        <mat-card-content class="m-2">
          <p>Solicitud: {{cotizacion?.id_solicitud}}</p>
          <p>{{cotizacion?.mensajes}}</p>
          <p><strong>Consulte con su productor.</strong></p>

        </mat-card-content>
      </mat-card>

    </ng-container>
    <ng-template #emitida>
      <mat-card class="cotizacion mt-4" style="max-width: 50%;">
        <mat-card-header>
          <div class="text-center">
            <h2 style="color: var(--secondary-500);">{{ nombre | titlecase }}</h2>
            <p>Ya tenemos tu póliza</p>
            <p>Descarga el PDF con la documentación.</p>
          </div>
        </mat-card-header>
        <div class="text-center" style="background-color: #fff;">
          <img mat-card-image class="mt-sm-2" src="assets/iconos/logosmg.png" alt="SMG Seguros" width="150px">
        </div>
        <mat-card-content class="m-2">
          <ng-container *ngIf="cotizacion?.nro_poliza != ''; else poliza">
            <h3 style="text-align: center; color: var(--primary-500);">Póliza</h3>
            <p class="valor"><strong>{{cotizacion?.nro_poliza}}</strong></p>
          </ng-container>
          <ng-template #poliza>
            <h3 style="text-align: center; color: var(--primary-500);">Solicitud</h3>
            <p class="valor"><strong>{{cotizacion?.id_solicitud}}</strong></p>
          </ng-template>


          <button *ngIf="cotizacion?.reporte != ''" mat-button (click)="downloadPdf()"><mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="download"></mat-icon> Descargar</button>

        </mat-card-content>
      </mat-card>
    </ng-template>










  </ng-template>

</div>
